export const Text = ({ children, as: Component = 'p', className }) => (
	<Component className={className}>{children}</Component>
);
